import React from 'react';
import PropTypes from 'prop-types';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import ManagedAccountModelUpdateRequestNoteLayout from './ManagedAccountModelUpdateRequestNoteLayout';


function ManagedAccountModelUpdateRequestNotes({
  collection,
  refreshCollection,
  notesPortalRef,
}) {
  return (
    <MetaCollectionFormInline
      collection={collection}
      padding={'none'}
      FormProps={{
        padding: 'none',
        margin: 'none',
        layout: ManagedAccountModelUpdateRequestNoteLayout,
        LayoutProps: {
          notesPortalRef,
        },
        readonly: true, // <--- Hides default Submit button
        onSubmit: refreshCollection,
      }}
    />
  );
}

ManagedAccountModelUpdateRequestNotes.propTypes = {
  collection: PropTypes.object.isRequired,
  refreshCollection: PropTypes.func.isRequired,
  notesPortalRef: PropTypes.object.isRequired,
};

export default ManagedAccountModelUpdateRequestNotes;
